export default __webpack_public_path__ + "static/media/tracks-image.4909cc91.jpg";